<template>
  <div class="page">
    <div class="title">
      <h2>Contact us</h2>
      <h4>We're happy to help you!</h4>
    </div>
    <div class="content">
      <div class="border">
        <div>
          <h3>StackAssist Support</h3>
          <p>
            <span class="highlight">E.</span>
            <a :href="helpdeskMailURL">{{ helpdeskMail }}</a>
            <br />
            <span class="highlight">T.</span>
            <a href="tel:+31880234302">+31 (0)88 - 0234 302</a>
          </p>
        </div>
        <div>
          <h3>StackAssist documentation</h3>
          <router-link :to="{ name: 'help' }" tag="a"> Help page </router-link>
          <a :href="documentation.TERMS_AND_CONDITIONS" target="_blank">
            General terms and conditions
          </a>
          <a :href="documentation.SUPPORT_PACK" target="_blank">
            Support pack
          </a>
          <a :href="documentation.API_DOCS" target="_blank">
            API documentation
          </a>
        </div>
      </div>
      <div class="border">
        <div>
          <h3>Contact us</h3>
          <p>
            <span class="highlight">E.</span>
            <a :href="infoMailURL">{{ infoMail }}</a>
            <br />
            <span class="highlight">T.</span>
            <a href="tel:+3188-0234300">+31 (0)88 - 0234 300</a>
          </p>
        </div>
        <div class="noPMargin">
          <h3>Visit us</h3>
          <p>Faes</p>
          <p>Hamelendijk 2</p>
          <p>5541 RA Reusel</p>
          <p>Netherlands</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactInfo from '@/constants/contactInfo'
import { DOCUMENTATION } from '@/constants/documentation'

export default {
  data() {
    return {
      id: this.$route.params.id,
      helpdeskMail: contactInfo.mail,
      helpdeskMailURL: `mailto:${contactInfo.mail}`,
      infoMail: contactInfo.infoMail,
      infoMailURL: `mailto:${contactInfo.infoMail}`,
    }
  },

  computed: {
    documentation() {
      return DOCUMENTATION
    },
  },
}
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.page h2 {
  font-size: 36px;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}

.content > div {
  width: 100%;
}

.border {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
}

.border > div {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.noPMargin p {
  margin: 0;
}

.highlight {
  color: #ea8700;
  font-weight: bold;
  font-size: x-large;
}
</style>
